import React from "react";
import MegaMenuLink from "./MegaMenuLink";
import { ArrowUpRightIcon } from "../icons";
import { getMegaMenuMeta, groupChildrenByCategory } from "./megaMenuUtils";

const MegaMenuPanel = ({ navItem, panelId, hidden }) => {
  const meta = getMegaMenuMeta(navItem);
  const isFlat = meta.layout === "flat";
  const flatLinks = navItem.children || [];
  const columnGroups = isFlat ? [] : groupChildrenByCategory(flatLinks);

  return (
    <div
      id={panelId}
      className={`bv-mega-header__mega-panel ${
        isFlat
          ? "bv-mega-header__mega-panel--flat"
          : "bv-mega-header__mega-panel--grouped"
      }`}
      role="region"
      aria-label={meta.title}
      hidden={hidden}
    >
      <div className="bv-mega-header__mega-inner">
        <div className="bv-mega-header__mega-feature">
          <h2 className="bv-mega-header__mega-title">{meta.title}</h2>
          {meta.description && (
            <p className="bv-mega-header__mega-description">
              {meta.description}
            </p>
          )}
          <a className="bv-mega-header__mega-cta" href={meta.ctaURL}>
            <span>{meta.ctaText}</span>
            <ArrowUpRightIcon
              className="bv-mega-header__mega-cta-icon"
              size={18}
            />
          </a>
        </div>

        {isFlat ? (
          <ul className="bv-mega-header__mega-grid">
            {flatLinks.map(link => (
              <li key={link.assetID} className="bv-mega-header__mega-grid-item">
                <MegaMenuLink href={link.pageURL}>{link.pageName}</MegaMenuLink>
              </li>
            ))}
          </ul>
        ) : (
          <div className="bv-mega-header__mega-columns">
            {columnGroups.map((group, groupIndex) => {
              const columnTitles = navItem.megaMenu?.columnTitles;
              const columnTitle =
                (Array.isArray(columnTitles) && columnTitles[groupIndex]) ||
                group.title;
              return (
                <div
                  key={columnTitle || group.links[0]?.assetID}
                  className="bv-mega-header__mega-column"
                >
                  {columnTitle && (
                    <p className="bv-mega-header__mega-column-title">
                      {columnTitle}
                    </p>
                  )}
                  <ul className="bv-mega-header__mega-list">
                    {group.links.map(link => (
                      <li
                        key={link.assetID}
                        className="bv-mega-header__mega-list-item"
                      >
                        <MegaMenuLink href={link.pageURL}>
                          {link.pageName}
                        </MegaMenuLink>
                      </li>
                    ))}
                  </ul>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default MegaMenuPanel;
